import { Component, NgZone, OnDestroy, OnInit, inject } from '@angular/core';

import { environment } from '../environments/environment';
import { ProfileService } from './profile.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private profileService = inject(ProfileService);
  private ngZone = inject(NgZone);


  env = environment;
  title = 'tasks-ng';
  authenticated = false;
  private profileLoginHandler: () => void;

  constructor() {
    this.authenticated = this.profileService.isAuthenticated();
  }

  ngOnInit(): void {
    this.profileLoginHandler = () => {
      // Run inside Angular zone to trigger change detection
      this.ngZone.run(() => {
        this.authenticated = this.profileService.isAuthenticated();
      });
    };
    window.addEventListener('profile:loaded', this.profileLoginHandler);
  }

  ngOnDestroy(): void {
    window.removeEventListener('profile:loaded', this.profileLoginHandler);
  }

  get isAuthenticated(): boolean {
    return this.authenticated;
  }

  onLogin(): void {
    this.profileService.login();
  }
  onLogout(): void {
    sessionStorage.clear();
    localStorage.clear();
    this.authenticated = false;
    this.profileService.logout();
  }
}
